const eventTileTypes = {
  'm.room.message': 'messages.MessageEvent',
  'm.sticker': 'messages.MessageEvent',
  'g.integration.jira_cloud.external': 'messages.IntegrationEventExternal',
  'g.integration.trello.external': 'messages.IntegrationEventExternal',
  'g.integration.jira_server.external': 'messages.IntegrationEventExternal',
  'g.integration.github.external': 'messages.IntegrationEventExternal',
  'g.integration.recharge.external': 'messages.IntegrationEventExternal',
  'g.integration.shopify_v2.external': 'messages.IntegrationEventExternal',
}

const stateEventTileTypes = {
  'm.room.topic': 'messages.TextualEvent',
  'g.state': 'messages.StateEvent',
  'g.assign': 'messages.StateEvent',
  'g.integrations.jira_cloud': 'messages.IntegrationEvent',
  'g.integrations.trello': 'messages.IntegrationEvent',
  'g.integrations.jira_server': 'messages.IntegrationEvent',
  'g.integrations.github': 'messages.IntegrationEvent',
  'g.integrations.recharge': 'messages.IntegrationEvent',
  'g.integrations.shopify_v2': 'messages.IntegrationEvent',
}

export function getHandlerTile(ev) {
  const type = ev.getType()

  // Ensure that g.assign events that doesnt have agent_id doesnt render.
  // This happens when we make the agent a participant of the room without
  // assigning the room to the agent
  if (type === 'g.assign') {
    const { agent_id: agentId, team_id: teamId } = ev.getContent()
    const {
      agent_id: previousAgentId,
      team_id: previousTeamId,
    } = ev.getPrevContent()
    if (!(agentId !== previousAgentId || teamId !== previousTeamId))
      return undefined
  }

  return ev.isState() ? stateEventTileTypes[type] : eventTileTypes[type]
}
